/* eslint-disable no-case-declarations */
import React from "react";
import { useNavigate } from "react-router-dom";
import "./HeaderFilterCourses.scss";
import { HeaderFilterCoursesProps } from ".";
import FilterCourses from "./FilterCourses";
import "./stylesMobile.scss";
import Input from "common/components/Input/Input";

const HeaderFilterCoursesMobile = ({
  onChangeText,
  value,
  onLastExercise,
  onChangeLevel,
  levels,
  dataLastExercise
}: HeaderFilterCoursesProps) => {
  const navigate = useNavigate();

  return (
    <div className="header-filter-courses-mobile-wrapper">
      <div className="header-filter-courses-mobile-top-container">
        <div
          className="header-filter-btn-student-folder"
          onClick={() => navigate("/student_folder")}>
          תיק תלמיד
        </div>

        <div className="header-filter-courses-mobile-top-left">
          {dataLastExercise && (
            <div className="save-btn-mobile" onClick={onLastExercise}>
              <span>תרגיל אחרון</span>
            </div>
          )}
          <FilterCourses onChangeLevel={onChangeLevel} levels={levels} />
        </div>
      </div>
      <div className="header-filter-search">
        <Input
          isMobile
          className="header-filter-search-input"
          placeholder="חיפוש"
          onChange={(val) => onChangeText && onChangeText(val.target.value)}
          value={value}
          showSearchIcon={true}
          showClearButton={!!value}
          onClear={() => onChangeText && onChangeText("")}
        />
      </div>
    </div>
  );
};

export default HeaderFilterCoursesMobile;
